module.exports = __webpack_public_path__ + "static/fabrica-12be79e02106676a5a1dcbca641e0fe2.png";